import { getStatusLabel } from '../utils';
import { OrderStatus as OrderStatusEnum } from '../types';
import '@shared/styles/status-tag.css';

const ORDER_STATUS_COLORS: Record<string, { bg: string; color: string }> = {
  [OrderStatusEnum.PENDING]: { bg: '#fef3c7', color: '#92400e' },
  [OrderStatusEnum.CONFIRMED]: { bg: '#dbeafe', color: '#1e40af' },
  [OrderStatusEnum.IN_PROGRESS]: { bg: '#3b82f6', color: '#fff' },
  [OrderStatusEnum.READY]: { bg: '#86efac', color: '#166534' },
  [OrderStatusEnum.IN_DELIVERY]: { bg: '#22d3ee', color: '#0e7490' },
  [OrderStatusEnum.DELIVERED]: { bg: '#22c55e', color: '#fff' },
  [OrderStatusEnum.CANCELED]: { bg: '#9ca3af', color: '#1f2937' },
};

const DEFAULT_COLORS = { bg: '#e5e7eb', color: '#374151' };

interface OrderStatusProps {
  status: string | OrderStatusEnum;
}

export default function OrderStatus({ status }: OrderStatusProps) {
  const label = getStatusLabel(status);
  const { bg, color } = ORDER_STATUS_COLORS[status] ?? DEFAULT_COLORS;
  return (
    <span
      className="status-tag"
      style={{ backgroundColor: bg, color }}
    >
      {label}
    </span>
  );
}
